<template>
  <swiper :options="options" ref="gallery_swiper">
    <slot></slot>

    <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
    <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
  </swiper>
</template>

<script>
export default {
  name: 'Gallery',

  data() {
    return {
      options: {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/Gallery.vue